<template>
  <span class="code" :class="{fasong: (!stop)}" @click="clickHandler()">
    {{ stop?'获取验证码': `(${mytimer})秒后重新获取` }}
  </span>
</template>
<script>
export default {
  name: 'getAuthCode',
  data () {
    return {
      stop: true,
      mytimer: this.timer,
      Interval: null
    }
  },
  methods: {
    clickHandler (e) {
      if (!this.phone) {
        this.$emit('input-error', '请输入手机号')
        return false
      } else {
        if (!(this.phone.length === 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(this.phone))) {
          this.$emit('input-error', '请输入正确的手机号')
          return false
        }
        if (this.stop) {
          this.$emit('retrieving', this.mytimer)
          this.startTimer()
        }
      }
    },
    update () {
      if (this.mytimer <= 1) {
        // 重置计数
        this.mytimer = this.timer
        // 清除计时器
        clearInterval(this.Interval)
        // 允许启动倒计时
        this.stop = true
      } else {
        // 倒计时
        this.mytimer--
      }
    },
    startTimer () {
      // 开始循环执行update函数
      this.Interval = setInterval(this.update, 1000)
      // 禁止启动倒计时
      this.stop = false
    }
  },
  props: {
    timer: {
      default: 90,
      type: Number
    },
    phone: ''
  }
}
</script>
<style scoped>
  .code{border:none; width:120px; height:38px; line-height:38px; text-align:center; color:#fff; background:#ff3633; display:block; float:right; border-radius:5px; cursor:pointer;}
  .fasong{width:120px; height:38px; line-height:38px; text-align:center; color:#fff; background:#ccc; display:block; float:right; border-radius:5px; cursor:pointer;}
</style>



// WEBPACK FOOTER //
// src/components/common/common/getAuthCode.vue